// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__Tl2B4","productName":"Table_productName__1oMEz"};